module.exports = __webpack_public_path__ + "img/chaos_champion_small.2e687850.png";